import { useLang } from "@/i18n";

export const Marquee = () => {
    const { t } = useLang();
    const text = t("marquee");
    return (
        <div
            data-testid="editorial-marquee"
            className="relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#0A0A0D] py-5 select-none"
        >
            <div className="flex whitespace-nowrap animate-marquee w-max">
                <span className="ff-accent text-sm md:text-base tracking-[0.35em] text-[#D4AF37]/50 pr-4">
                    {text.repeat(3)}
                </span>
                <span className="ff-accent text-sm md:text-base tracking-[0.35em] text-[#D4AF37]/50 pr-4">
                    {text.repeat(3)}
                </span>
            </div>
        </div>
    );
};
